import { render, staticRenderFns } from "./NicheIcon.vue?vue&type=template&id=3168171a&scoped=true"
import script from "./NicheIcon.vue?vue&type=script&lang=js"
export * from "./NicheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3168171a",
  null
  
)

export default component.exports